import { Routes } from '@angular/router';
import { SupplierDetailsComponent } from './supplier-details/supplier-details.component';
import { SupplierComponent } from './supplier/supplier.component';

export const SupplierRoutingModule: Routes = [
	{ path: 'supplier', component: SupplierComponent },
	{ path: 'supplier/:supplierId', component: SupplierDetailsComponent },
];
